import { cn } from '../../utils/cn'

export interface DividerProps {
  orientation?: 'horizontal' | 'vertical'
  className?: string
}

/** Stitch separates with a 1px primary line at 10% opacity, never a shadow. */
export function Divider({ orientation = 'horizontal', className }: DividerProps) {
  return (
    <hr
      aria-orientation={orientation}
      className={cn(
        'border-0 bg-primary/10',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px self-stretch',
        className,
      )}
    />
  )
}
